import React from 'react';
import { FiBarChart2 } from 'react-icons/fi';
import ProductAnalyticsDashboard from '../components/productAnalytics/ProductAnalyticsDashboard';
import './ProductAnalytics.css';

const ProductAnalytics = () => (
  <div className="product-analytics-page list-page">
    <div className="page-header">
      <h1>
        <FiBarChart2 /> Product Analytics
      </h1>
    </div>
    <p className="product-analytics-intro">
      See how the dashboard is being adopted across users and which functionality gets the most use.
      The UI shows the last 7 days; raw events are kept in the database for longer-range queries.
    </p>
    <ProductAnalyticsDashboard />
  </div>
);

export default ProductAnalytics;
